import { methodPut, methodGet, methodPost, methodDelete, methodPatch } from './methods';
import { API_INFO } from '../constants';

export async function getAllContests(payload) {
    return methodGet(API_INFO + 'concourse/concourse/', payload);
  }
  
  export async function getIdContest(id) {
    return methodGet(API_INFO + `concourse/concourse/${id}/`);
  }
  
  export async function createContest(payload) {
    return methodPost(API_INFO + `concourse/concourse/`, payload);
  }
  
  export async function editContest(id, payload) {
    return methodPut(API_INFO + `concourse/concourse/${id}/`, payload);
  }
  
  export async function deleteContest(id) {
    return methodDelete(API_INFO + `concourse/concourse/${id}/`);
  }
  
  export async function getStatistics(payload) {
    return methodGet(API_INFO + 'concourse/concourse/statistics/', payload);
  }
  
  export async function getDetailedStatistics(payload) {
    return methodGet(API_INFO + 'concourse/concourse/detailed-statistics/', payload);
  }
  
  export async function getConcourseOrdersArticles(payload) {
    return methodGet(API_INFO + 'storehouse/orders/articles/', payload);
  }
  